import * as SparkMD5 from "spark-md5";

export class Util {
  constructor() { }

  getBase64(file: any) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }

  incrementalMD5(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      const spark = new SparkMD5.ArrayBuffer()
      const chunkSize = 2097152 // Read in chunks of 2MB
      const chunks = Math.ceil(file.size / chunkSize)
      let currentChunk = 0

      fileReader.onload = function (event: any): void {
        if (event.target.result != null) { }
        spark.append(event.target.result) // Append array buffer
        ++currentChunk
        currentChunk < chunks ? loadNext() : resolve(spark.end()) // Compute hash
      }

      function loadNext() : void {
        const start = currentChunk * chunkSize
        const end = start + chunkSize >= file.size ? file.size : start + chunkSize
        fileReader.readAsArrayBuffer(File.prototype.slice.call(file, start, end))
      }

      loadNext()
    })
  }


  computeChecksumMd5(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const chunkSize = 2097152;
      const spark = new SparkMD5.ArrayBuffer();
      const fileReader = new FileReader();
      let cursor = 0;
      fileReader.onerror = function (): void {
        reject('MD5 computation failed - error reading the file');
      };
      function processChunk(chunk_start: number): void {
        const chunk_end = Math.min(file.size, chunk_start + chunkSize);
        fileReader.readAsArrayBuffer(file.slice(chunk_start, chunk_end));
      }
      fileReader.onload = function (e: any): void {
        spark.append(e.target.result);
        cursor += chunkSize;

        if (cursor < file.size) {
          processChunk(cursor);
        } else {
          resolve(btoa(spark.end(true)));
        }
      };

      processChunk(0);
    });
  }
}